module.exports = __webpack_public_path__ + "img/icon-personajes.2c2ef73a.svg";